import { Injectable, Inject } from '@angular/core';
import { Observable, ConnectableObservable } from 'rxjs';
import { TableViews } from './table-models';
import { publishLast, filter } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { CORE_CONFIG } from '../environment';

@Injectable({
  providedIn: 'root'
})
export class TableService {

  tableViews: Observable<TableViews>;

  private _baseURL: string;

  constructor(private httpClient: HttpClient,
    private authService: AuthService,
    @Inject(CORE_CONFIG) private coreConfig: any) {
    this._baseURL = `${this.coreConfig.endpoint}api/v1/table/dashboard`;
    this.authService.isLoggedIn.pipe(filter(r => r === true)).subscribe(logged =>
      this.tableViews = this.getTableViews());
  }

  private getTableViews(): Observable<TableViews> {
    const tableViews = this.httpClient.get(this._baseURL).pipe(publishLast());
    (tableViews as ConnectableObservable<TableViews>).connect();
    return tableViews;
  }

}
